var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 19,
    viewBox: "0 0 11 19",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.15858 9.46458L0.465992 16.2472C-0.155333 16.8769 -0.155333 17.8981 0.465992 18.5277C1.08732 19.1574 2.09495 19.1574 2.71628 18.5277L10.534 10.6049C11.1553 9.97518 11.1553 8.95399 10.534 8.32431C10.532 8.32232 10.5296 8.31984 10.5272 8.31786C10.5247 8.31538 10.5227 8.31339 10.5208 8.31091L2.78629 0.472385C2.47538 0.157296 2.06851 1.12653e-06 1.66115 1.09092e-06C1.25379 1.05531e-06 0.846916 0.157296 0.536009 0.472384C-0.085317 1.10207 -0.0853171 2.12325 0.536008 2.75294L7.15858 9.46458Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.4d0eee76bf2205e8c208686cb304eac7.svg";
export { ForwardRef as ReactComponent };